import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { msg } from 'api';

export default function CouponsInfoSection({ collapsed = false, collapseInfoSection, expandInfoSection }) {
  const toggleBtnText = collapsed ? 'Show' : 'Hide';
  const toggleBtnClickHandler = collapsed ? expandInfoSection : collapseInfoSection;

  return (
    <section className="gn-content cou-infoSection">
      <div className="cou-infoSection__mainWrapper">
        <div className="cou-infoSection__titlebar">
          <h5 className="cou-infoSection__title">
            <span className="icon icon__coupon cou-infoSection__icon" />{`Why use ${msg.retailer} Coupons?`}
          </h5>
          <button
            className="gn-textLink cou-infoSection__toggleBtn"
            onClick={toggleBtnClickHandler}
            onKeyPress={toggleBtnClickHandler}
          >
            {toggleBtnText}
          </button>
        </div>
        <div className={classNames('cou-infoSection__body', collapsed && 'cou-infoSection__body--collapsed')}>
          <div className="cou-infoSection__bodyWrapper">
            <div className="cou-infoSection__info cou-infoSection__info--save">
              <p className="cou-infoSection__infoText">
                Save money with a coupon for <b>one product</b> from a range.
              </p>
            </div>
            <div className="cou-infoSection__info cou-infoSection__info--money">
              <p className="cou-infoSection__infoText">
                You&apos;ll get <b>money off the price shown</b>, even when there&apos;s an offer.
              </p>
            </div>
            <div className="cou-infoSection__info cou-infoSection__info--product">
              <p className="cou-infoSection__infoText">
                Add it to your trolley and the coupon will be <b>automatically applied</b>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

CouponsInfoSection.propTypes = {
  collapsed: PropTypes.bool,
  collapseInfoSection: PropTypes.func.isRequired,
  expandInfoSection: PropTypes.func.isRequired,
};
